/**
 * Patient portal API client — thin fetch wrapper that sends credentials
 * (httpOnly cookies) with every call and normalises errors.
 */
import { API } from "./api";

async function req(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}/patient${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    let msg = data?.detail || data?.message;
    if (Array.isArray(msg)) msg = msg.map((e) => (e?.msg || JSON.stringify(e))).join(" ");
    if (!msg) msg = res.status === 401 ? "Please sign in again." : `Server ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const patientApi = {
  register: (b) => req("/auth/register", { method: "POST", body: b }),
  login: (b) => req("/auth/login", { method: "POST", body: b }),
  logout: () => req("/auth/logout", { method: "POST" }),
  me: () => req("/auth/me"),
  refresh: () => req("/auth/refresh", { method: "POST" }),
  forgot: (email) => req("/auth/forgot-password", { method: "POST", body: { email } }),
  reset: (token, password) => req("/auth/reset-password", { method: "POST", body: { token, password } }),
  updateProfile: (b) => req("/profile", { method: "PUT", body: b }),
  listFamily: () => req("/family"),
  addFamily: (b) => req("/family", { method: "POST", body: b }),
  editFamily: (id, b) => req(`/family/${id}`, { method: "PUT", body: b }),
  deleteFamily: (id) => req(`/family/${id}`, { method: "DELETE" }),
  book: (b) => req("/rides/schedule", { method: "POST", body: b }),
  reschedule: (id, b) => req(`/rides/${id}/reschedule`, { method: "POST", body: b }),
  payHold: (id) => req(`/rides/${id}/pay-hold`, { method: "POST" }),
  share: (id) => req(`/rides/${id}/share`, { method: "POST", body: {} }),
  rate: (id, b) => req(`/rides/${id}/rate`, { method: "POST", body: b }),
  cancelSeries: (seriesId) => req(`/series/${seriesId}/cancel-remaining`, { method: "POST" }),
  listRides: () => req("/rides"),
  getRide: (id) => req(`/rides/${id}`),
  cancelRide: (id, reason, detail) => req(`/rides/${id}/cancel`, { method: "POST", body: { reason, detail } }),
  listEstimates: () => req("/estimates"),
  saveEstimate: (b) => req("/estimates", { method: "POST", body: b }),
  deleteEstimate: (id) => req(`/estimates/${id}`, { method: "DELETE" }),
  // Wallet — saved cards management
  deleteCard: (pmId) => req(`/payment-methods/${pmId}`, { method: "DELETE" }),
  setDefaultCard: (pmId) => req(`/payment-methods/set-default`, { method: "POST", body: { stripe_payment_method_id: pmId } }),
  addCardCheckout: (originUrl) => req(`/payment-methods/add-card-checkout`, { method: "POST", body: { origin_url: originUrl } }),
  confirmAddedCard: (sessionId) => req(`/payment-methods/confirm`, { method: "POST", body: { session_id: sessionId } }),
};
